__turbopack_context__.v({
  "composer": "CyZ9Nq_composer",
  "composerField": "CyZ9Nq_composerField",
  "disclaimer": "CyZ9Nq_disclaimer",
  "send": "CyZ9Nq_send",
  "textarea": "CyZ9Nq_textarea",
});
